<template>
  <div>
    <v-swatches
      v-model="colourTag"
      swatches="text-advanced"
      show-fallback
      fallback-input-type="color"
      @input="$emit('input', colourTag)">
    </v-swatches>
    <div class="form-invalid-feedback" v-if="hasError()">
      {{getError()}}
    </div>
    <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
  </div>
</template>


<script>
import colourMixin from '@/mixins/colour'
import formField from '@/mixins/formField'

import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  name: "FormColourTag",
  mixins: [colourMixin, formField],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    popupName: {
      type: String,
      default: 'Colour Select'
    },
    value: String,
    placeholder: String,
    field: String,
    note: String
  },
  components: {
    VSwatches
  },
  data() {
    return {
      editingLabel: null,
      colourTag: this.value
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.colourTag = this.value

        // Default colour if nothing set
        if(this.colourTag == null || this.colourTag == '') {
          this.colourTag = '#fc5c65'
          this.$emit('input', this.colourTag)
        }
      },
      deep: true
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
  }
};
</script>